import { ProtectedRouteUser } from '@/app/guards';
import { LAYOUT_X_PADDING } from '@/app/layouts/layoutConstants';
import { Footer } from '@/app/shell/Footer';
import Header from '@/app/shell/Header/Header';
import { isWorkspaceSourcesPath } from '@/shared/constants/routes';
import { cn } from '@/shared/utils';
import { OnboardingOverlay } from '@/view/features/onboarding';
import { TrialBanner } from '@/view/features/quota';
import { BreadcrumbsComponent } from '@/view/shared/Breadcrumbs';
import { PageHeaderSlotProvider } from '@/view/shared/PageHeader';
import { useAuthenticatedBreadcrumbsViewModel } from '@/viewmodel/features/project';
import { useDatasetContentViewModel } from '@/viewmodel/shared/sidebar';
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export default function AuthenticatedLayout() {
  const [headerTarget, setHeaderTarget] = useState<HTMLDivElement | null>(null);
  const breadcrumbItems = useAuthenticatedBreadcrumbsViewModel();
  const { pathname } = useLocation();
  const contentLayout = useDatasetContentViewModel();
  const isFullHeight = isWorkspaceSourcesPath(pathname);

  return (
    <ProtectedRouteUser needToExist={true}>
      <div className="flex relative flex-col w-full h-full bg-surface">
        <div className={`${LAYOUT_X_PADDING} py-2 border-b border-separator`}>
          <Header />
        </div>
        <div className={`${LAYOUT_X_PADDING} py-3 bg-surface border-y border-border`}>
          <BreadcrumbsComponent items={breadcrumbItems} />
        </div>
        <TrialBanner />
        <PageHeaderSlotProvider slot={{ target: headerTarget, insetClassName: LAYOUT_X_PADDING }}>
          <div ref={setHeaderTarget} className="shrink-0" />
          <div
            className={cn(
              'flex-1 bg-background min-h-0',
              isFullHeight && contentLayout === 'flush' ? 'overflow-hidden' : 'overflow-y-auto',
            )}
          >
            <main
              className={
                isFullHeight ? 'flex flex-col h-full' : `${LAYOUT_X_PADDING} py-4 mx-auto w-full`
              }
            >
              <Outlet />
            </main>
          </div>
        </PageHeaderSlotProvider>
        <Footer />
        <OnboardingOverlay />
      </div>
    </ProtectedRouteUser>
  );
}
